module.exports = "/fonts/Roboto-LightItalic.ttf?d63782f446a0cb341ae4ebf32c208343";